import { useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';
import styled from 'styled-components';

import { appInsightsPlugin } from 'app/modules/AppInsights';
import { ErrorDialog } from 'pkg/components/ErrorHandling/ErrorDialog';
import { HttpError } from 'pkg/httpClient/httpClient';

const Placeholder = styled.div`
  height: 60vh;
`;

export const HttpErrorFallback = ({ error, resetErrorBoundary }: FallbackProps): JSX.Element => {
  useEffect(() => {
    if (error instanceof HttpError) {
      appInsightsPlugin.trackException({ exception: error }, { type: 'HTTP Error' });
    }
  }, [error]);

  if (error instanceof HttpError) {
    return (
      <>
        <Placeholder />
        <ErrorDialog onClose={resetErrorBoundary} />
      </>
    );
  }

  throw error;
};
